
import { useParams, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import Chat from "@/components/Chat";
import { useAssistantData } from "@/hooks/useAssistantData";

const AssistantPage = () => {
  const { key_id } = useParams<{ key_id: string }>();
  const location = useLocation();
  
  let assistantKey = key_id;
  
  if (location.pathname.startsWith('/') && !location.pathname.includes('/assistant/')) {
    const rootKey = location.pathname.split('/')[1];
    if (rootKey && rootKey !== '') {
      assistantKey = rootKey;
    }
  }
  
  const { assistantData, isLoading } = useAssistantData(assistantKey);
  
  useEffect(() => {
    if (!isLoading && assistantData?.assistant_data?.hotel_details?.name) {
      document.title = `alfie — ${assistantData.assistant_data.hotel_details.name}`;
    } else {
      document.title = "alfie | Your 24/7 Concierge";
    }
  }, [assistantData, isLoading]);
  
  return (
    <>
      <Helmet>
        <title>
          {assistantData?.assistant_data?.hotel_details?.name 
            ? `alfie — ${assistantData.assistant_data.hotel_details.name}`
            : "alfie | Your 24/7 Concierge"}
        </title>
        <meta 
          name="description" 
          content={`Your 24/7 Concierge ${assistantData?.assistant_data?.hotel_details?.name ? `at ${assistantData.assistant_data.hotel_details.name}` : ''}`} 
        />
      </Helmet>
      <Chat urlSlug={assistantKey} />
    </>
  );
};

export default AssistantPage;
